import React, { useEffect, useState } from "react";
import { aboutMeType } from "../../../../common/interfaces/myProfile/personalDetails/aboutMeType";
import { leavesService } from "../../../../api/services/leavesService";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setLeaveEligibility,
  setRefreshLeaveEligibility,
} from "../../../../infra/aggregates/myProfile/leavesAggregates/leaveEligibilitySlice";

interface PropsValues {
  setLeaveEligibilityData: (data: any) => void;
}

function DTOLeaveEligibility({ setLeaveEligibilityData }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);

  const dispatch = useAppDispatch();

  async function getLeaveEligibility(companyId: number, empId: number) {
    dispatch(setRefreshLeaveEligibility(true));

    const response = await leavesService.getLeaveEligibilities(
      companyId,
      empId
    );
    if (response.response == "success") {
      dispatch(setRefreshLeaveEligibility(false));
      dispatch(setLeaveEligibility(response?.data));
      return setLeaveEligibilityData(response?.data);
    } else {
      dispatch(setRefreshLeaveEligibility(false));
    }
  }
  useEffect(() => {
    if (selector.emp_id && selector.company_id)
      getLeaveEligibility(selector.company_id, selector.emp_id);
  }, []);

  return <></>;
}
export default DTOLeaveEligibility;
